import { IDirectory } from '@common/types/directory';
import { IOption } from '@common/types';

export const typeOptionsMapper = (directories: IDirectory[]): IOption[] => {
  return directories.map((directory) => ({
    id: directory.id,
    name: directory.value
  }));
};
